import { assetUrl } from "@/lib/api";

export const UserAvatar = ({ profile, size = "h-12 w-12", textSize = "text-lg", testId }) => {
  const initials = (profile?.display_name || "?").slice(0, 2).toUpperCase();
  return (
    <div data-testid={testId} className={`${size} chrome-ring rounded-full p-[2px] shrink-0`}>
      {profile?.avatar_url ? (
        <img src={assetUrl(profile.avatar_url)} alt={profile.display_name} className="h-full w-full rounded-full object-cover bg-nw-surface" />
      ) : (
        <div className={`grid h-full w-full place-items-center rounded-full bg-nw-surface font-display font-bold ${textSize} text-slate-300`}>{initials}</div>
      )}
    </div>
  );
};

export const RoleBadge = ({ type, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-[0.2em] ${type === "creator" ? "bg-nw-red/15 text-nw-red ring-1 ring-nw-red/40" : "bg-slate-400/10 text-slate-300 ring-1 ring-slate-400/30"}`}>
    {type === "creator" ? "AI Creator" : "Fan"}
  </span>
);

export const PlanBadge = ({ tier }) => tier ? (
  <span data-testid="profile-plan-badge" className="inline-flex items-center rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-[0.2em] text-black bg-gradient-to-r from-slate-100 via-slate-400 to-slate-200">
    {tier === "pro" ? "Pro" : "Creator"}
  </span>
) : null;

export const SectionLabel = ({ children }) => (
  <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-nw-red">{children}</p>
);
